import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/i18n";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Technology from "@/components/Technology";
import Numbers from "@/components/Numbers";
import Manifesto from "@/components/Manifesto";
import Marquee from "@/components/Marquee";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1.05 });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    const onAnchor = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const el = document.querySelector(a.getAttribute("href"));
      if (el) {
        e.preventDefault();
        lenis.scrollTo(el, { offset: -72 });
      }
    };
    document.addEventListener("click", onAnchor);
    return () => {
      cancelAnimationFrame(raf);
      document.removeEventListener("click", onAnchor);
      lenis.destroy();
    };
  }, []);

  return (
    <LanguageProvider>
      <div className="bg-background text-foreground min-h-screen" data-testid="app-root">
        <Header />
        <main>
          <Hero />
          <Technology />
          <Numbers />
          <Manifesto />
          <Marquee />
          <Contact />
        </main>
        <Footer />
        <Toaster theme="dark" position="bottom-right" />
      </div>
    </LanguageProvider>
  );
}

export default App;
